import styled from "@emotion/styled";
import { 
  Search as SearchIcon,
  Chat as ChatIcon,
  PlayArrow as PlayIcon
} from "@mui/icons-material";
import { useTheme } from "@emotion/react";

export const MotivationSection = () => {
  const themeContext = useTheme();

  return (
    <MotivationContent>
      <StepCard>
        <StepIcon>
          <SearchIcon />
        </StepIcon>
        <StepContent>
          <StepTitle>Suche perfekte Lehrer*innen</StepTitle>
          <StepText>
            Wähle deine Universität aus, suche deine Kurse in der Kurssuche und sehe
            direkt welche Nachhilfelehrer*innen zu dir passen. Dabei soll dir
            Beschreibung, Preis, Bewertung, Kommentare anderer und die Angabe, ob
            Onlineunterricht angeboten wird helfen.
          </StepText>
        </StepContent>
      </StepCard>

      <StepCard>
        <StepIcon>
          <ChatIcon />
        </StepIcon>
        <StepContent>
          <StepTitle>Besprecht die Details</StepTitle>
          <StepText>
            Schreibe über unseren Chat, ganz einfach mit Lehrer*innen über alle
            notwendigen Details. Planung des Unterrichts, Fähigkeiten der Lehrenden
            usw.
          </StepText>
        </StepContent>
      </StepCard>

      <StepCard>
        <StepIcon>
          <PlayIcon />
        </StepIcon>
        <StepContent>
          <StepTitle>Und dann geht's schon los</StepTitle>
          <StepText>
            Dann kannst du direkt loslegen! Keine weiteren nervigen Hürden. Und wenn
            es dir gefällt, hilft dir unsere Website vielleicht auch noch in anderen
            Kursen. Wir würden uns freuen!
          </StepText>
        </StepContent>
      </StepCard>
    </MotivationContent>
  );
};

const MotivationContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  width: 100%;
  box-sizing: border-box;
`;

const StepCard = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 1.5rem;
  background: white;
  border-radius: 12px;
  padding: 2rem;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  border-left: 4px solid ${props => props.theme.primaryColor};
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
  }

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 1rem;
    padding: 1.5rem;
    border-left: none;
    border-top: 4px solid ${props => props.theme.primaryColor};
  }

  @media (max-width: 480px) {
    padding: 1rem;
  }
`;

const StepIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 60px;
  height: 60px;
  background: ${props => props.theme.primaryColor};
  border-radius: 50%;
  flex-shrink: 0;

  svg {
    font-size: 2rem;
    color: white;
  }

  @media (max-width: 768px) {
    width: 50px;
    height: 50px;
    
    svg {
      font-size: 1.5rem;
    }
  }
`;

const StepContent = styled.div`
  flex: 1;
  min-width: 0;
`;

const StepTitle = styled.h3`
  margin: 0 0 1rem 0;
  color: ${props => props.theme.mainTextColor};
  font-size: 1.5rem;
  font-weight: 600;
  line-height: 1.3;

  @media (max-width: 768px) {
    font-size: 1.3rem;
  }

  @media (max-width: 480px) {
    font-size: 1.2rem;
  }
`;

const StepText = styled.p`
  margin: 0;
  color: ${props => props.theme.mainTextColor};
  font-size: 1rem;
  line-height: 1.6;
  word-wrap: break-word;
  overflow-wrap: break-word;

  @media (max-width: 768px) {
    font-size: 0.95rem;
  }
`;
